require('./hireCardRevolvingView.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { getRevolvingSubType } = require('utilities/contactCenter/cardHireHelper');

// @actions
const hireCardRevolvingActions = require('actions/hireCardRevolving');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const profileActions = require('actions/profile');
const shippingAddressAction = require('actions/shippingAddress');
const mergePreContractualsPDF = require('actions/mergePreContractualsPDF');
const blockedAccountsAction = require('actions/blockedAccounts');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const HireCardRevolvingStep1 = require('components/hire/cardRevolving/hireCardRevolvingStep1/hireCardRevolvingStep1');
const HireCardRevolvingStep2 = require('components/hire/cardRevolving/hireCardRevolvingStep2/hireCardRevolvingStep2');
const HireCardRevolvingStep3 = require('components/hire/cardRevolving/hireCardRevolvingStep3/hireCardRevolvingStep3');
const HireCardRevolvingStep4 = require('components/hire/cardRevolving/hireCardRevolvingStep4/hireCardRevolvingStep4');
const HireCardRevolvingStep5 = require('components/hire/cardRevolving/hireCardRevolvingStep5/hireCardRevolvingStep5');
const HireCardRevolvingSuccess = require('components/hire/cardRevolving/hireCardRevolvingSuccess/hireCardRevolvingSuccess');
const HireCardRevolvingError = require('components/hire/cardRevolving/hireCardRevolvingError/hireCardRevolvingError');
const HireCardSidebar = require('components/hire/hireCardSidebar/hireCardSidebar');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

// @constants
const {
    CARD_REVOLVING_PRODUCT_TYPE,
    CARD_REVOLVING_PRODUCT_SUBTYPE,
    CARD_REVOLVING_PRODUCT_STANDARD,
    THIRD_STEP,
    WIZARD_FIRST_STEP
} = require('constants/index');
const { HIRE_CARD_REVOLVING } = require('constants/operationCodesAccounts');
const {
    HIRE_CARD_REVOLVING_ENABLED,
    WEB_INACTIVE_ACCOUNT_ENABLED,
    MESSAGE_HIRE_24H
} = require('constants/flagBasedFeatures');

class HireCardRevolvingView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
        this.handlECancel = this.handlECancel.bind(this);
        const revolvingEnabled = props.immFlagBasedFeatures.get(HIRE_CARD_REVOLVING_ENABLED);

        if (!revolvingEnabled) {
            props.history.push('/myprofile/cards');
        }
    }

    componentDidMount() {
        const {
            getScoring,
            getBlockedAccounts,
            immAccounts,
            immHireCardRevolving,
            immFlagBasedFeatures,
            getshippingAddressList,
            resetPrecontractualDocumentMail,
        } = this.props;

        resetPrecontractualDocumentMail();

        if (!immHireCardRevolving.get('fetchSuccessScoring') && immFlagBasedFeatures.get(HIRE_CARD_REVOLVING_ENABLED)) {
            getScoring();
        }

        getshippingAddressList();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CARD_REVOLVING);
    }

    componentWillUnmount() {
        const {
            reset,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        reset();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
        }
    }

    getProcessDetail() {
        return `${CARD_REVOLVING_PRODUCT_TYPE}.${CARD_REVOLVING_PRODUCT_SUBTYPE}`;
    }

    handleCancel() {
        this.props.history.push('/myprofile/cards');
    }

    isReady() { // it warns the user if he's about to lose changes
        const { immHireCardRevolving } = this.props;
        let showPreLeaveModal = true;

        if (immHireCardRevolving.get('visibleStep') === 1) {
            showPreLeaveModal = false;
        }

        return showPreLeaveModal;
    }

    buildSuccessful() {
        const {
            immAccounts,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardRevolving,
            immHireCreditLimit,
            immHirePaymentMethod,
            immProfile,
            immShippingAddressList
        } = this.props;
        const selectedAccount = immHireCardRevolving.getIn(['steps', THIRD_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);

        const processDetail = this.getProcessDetail();

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <HireCardRevolvingSuccess
                    immAccount={immAccount}
                    immHireCardRevolving={immHireCardRevolving}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immProfile={immProfile}
                    immShippingAddress={immShippingAddressList.get('shippingAddress')}
                    processDetail={processDetail}
                />
            </div>
        );
    }

    buildWizardHiringSteps() {
        const {
            handleAccountChange,
            handleAgreementCheckboxChange,
            hireCardRevolving,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardRevolving,
            immHireContactData,
            immHireCreditLimit,
            immHireInformation,
            immHiringProductInformation,
            immHirePaymentMethod,
            immProfile,
            immPreContractualMail,
            immPdfData,
            immShippingAddressList,
            requestProfile,
            requestPDFMerge,
            setAllAccountsToInactive,
            setHireCreditLimit,
            setShippingAddress,
            setVisibleStep,
            sendPrecontractualDocumentMail,
            sendPreContractualMail,
            setTermsAndCondsText,
            setWillCancel,
            toggleCreditLimitModal,
            validate,
            validateStep,
        } = this.props;

        const wizardActions = {
            cancel: this.handleCancel,
            finish: hireCardRevolving,
            setVisibleStep,
            setWillCancel,
            validateStep
        };

        const showPreLeaveModal = this.isReady();
        const immSteps = immHireCardRevolving.get('steps');

        const pack = immHireCardRevolving.get('pack');
        const subType = getRevolvingSubType(pack);
        const sendMailParams = {
            type: CARD_REVOLVING_PRODUCT_TYPE,
            subType,
            standar: CARD_REVOLVING_PRODUCT_STANDARD,
        };
        const nextButtonDisabledStep2 = immHireCardImageSelector.get('isFetching') || immHireCardNameSelector.get('isFetching');
        let operativeName;

        if (__CONTACT_CENTER__) {
            operativeName = 'operatives-revolvingCard';
        }

        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
        let hasShippingAddress = true;

        const tealium = {
            processDetail: this.getProcessDetail()
        };
        const loadingFlag = immHireCardRevolving.get('loadingFlag');

        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    <Wizard
                        actions={wizardActions}
                        immSteps={immSteps}
                        showPreLeaveModal={showPreLeaveModal}
                        stepsAmount={immSteps.size}
                        tealium={tealium}
                        visibleStep={immHireCardRevolving.get('visibleStep')}
                        wizardClass="hire-card-revolving__wizard"
                    >
                        <WizardStep
                            isLoading={loadingFlag}
                            cancelButton={true}
                            position="first"
                        >
                            <WebappRender>
                                <HireCardRevolvingStep1
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    hireCmsKey="revolving"
                                    immHireCardRevolving={immHireCardRevolving}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    requestPDFMerge={requestPDFMerge}
                                />
                            </WebappRender>
                            <ContactCenterRender>
                                <HireCardRevolvingStep1
                                    contractName="revolving"
                                    flagBasedFeatures={immFlagBasedFeatures}
                                    gestorCrossEnabled={gestorCrossEnabled}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    hireCmsKey="revolving"
                                    immHireCardRevolving={immHireCardRevolving}
                                    immHireInformation={immHireInformation}
                                    immHiringProductInformation={immHiringProductInformation}
                                    immPreContractualMail={immPreContractualMail}
                                    immProfile={immProfile}
                                    requestProfile={requestProfile}
                                    requestPDFMerge={requestPDFMerge}
                                    sendMailParams={sendMailParams}
                                    sendPreContractualMail={sendPreContractualMail}
                                    setTermsAndCondsText={setTermsAndCondsText}
                                />
                            </ContactCenterRender>
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            nextButtonDisabled={nextButtonDisabledStep2}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardRevolvingStep2
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardRevolving={immHireCardRevolving}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            nextButtonDisabled={immHireCreditLimit.get('isFetching')}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardRevolvingStep3
                                handleAccountChange={handleAccountChange}
                                immAccounts={immAccounts}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardRevolving={immHireCardRevolving}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                                setAllAccountsToInactive={setAllAccountsToInactive}
                                setHireCreditLimit={setHireCreditLimit}
                                toggleCreditLimitModal={toggleCreditLimitModal}
                                validate={validate}
                            />
                        </WizardStep>
                        <WizardStep
                            cancelButton={true}
                            onBackClick={false}
                            position="middle"
                        >
                            <HireCardRevolvingStep4
                                immHireContactData={immHireContactData}
                                immShippingAddressList={immShippingAddressList}
                                setShippingAddress={setShippingAddress}
                            />
                        </WizardStep>
                        <WizardStep
                            addLoadingBehaviour={true}
                            cancelButton={true}
                            immFinalButton={'hireCardRevolving-hire'}
                            isLoading={immHireCardRevolving.get('isFetching')}
                            onBackClick={false}
                            position="last"
                        >
                            <HireCardRevolvingStep5
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCardRevolving={immHireCardRevolving}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immPdfData={immPdfData}
                                immShippingAddress={immShippingAddressList.get('shippingAddress')}
                                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                operativeName={operativeName}
                                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                                setTermsAndCondsText={setTermsAndCondsText}
                            />
                        </WizardStep>
                    </Wizard>

                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                            <HireCardSidebar
                                hasShippingAddress={hasShippingAddress}
                                creditType="revolving"
                                immAccounts={immAccounts}
                                immAddress={immShippingAddress}
                                immGlobalVariables={immGlobalVariables}
                                immHireCardImageSelector={immHireCardImageSelector}
                                immHireCardNameSelector={immHireCardNameSelector}
                                immHireCreditLimit={immHireCreditLimit}
                                immHirePaymentMethod={immHirePaymentMethod}
                                immShippingAddressList={immShippingAddressList}
                                immProfile={immProfile}
                                revolvingPackId={immHireCardRevolving.get('pack')}
                                selectedAccount={immSteps.getIn([THIRD_STEP, 'accountId'])}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardRevolving, immFlagBasedFeatures } = this.props;
        const pageTitle = getFinalTitle('hireCardRevolving-pageTitle');
        const hasErrorScoring = !!immHireCardRevolving.get('errorScoring') ||
            (immHireCardRevolving.get('fetchSuccessScoring') && !immHireCardRevolving.get('enabled'));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText("hireCardRevolving-breadcrumb")
            }
        ];

        const processDetail = this.getProcessDetail();
        const hireRestrictionFlag = immHireCardRevolving.getIn(['steps', WIZARD_FIRST_STEP-1, 'hireRestriction']);
        const hireRestrictionFF = immFlagBasedFeatures.get(MESSAGE_HIRE_24H);

        let content;

        if (immHireCardRevolving.get('isFetchingScoring')) {
            content = <LoadingSection />;
        } else if (immHireCardRevolving.get('error') || hasErrorScoring) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardRevolvingError
                        immHireCardRevolving={immHireCardRevolving}
                        processDetail={processDetail}
                    />
                </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            content = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <HireCardRevolvingError
                        immHireCardRevolving={immHireCardRevolving}
                        processDetail={processDetail}
                        hireRestrictionFlag={hireRestrictionFlag}
                    />
                </div>
            );
        }
         else if (immHireCardRevolving.get('submitSuccessful')) {
            content = this.buildSuccessful();
        } else if (immHireCardRevolving.get('enabled')) {
            content = this.buildWizardHiringSteps();
        }

        return (
            <div className="hire-card-revolving">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={pageTitle}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireCardRevolvingView.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    getScoring: PropTypes.func.isRequired,
    getshippingAddressList: PropTypes.func,
    handleAccountChange: PropTypes.func.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    hireCardRevolving: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    match: PropTypes.object,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = HireCardRevolvingView;
module.exports.HireCardRevolvingView = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireCardRevolving: state.hireCardRevolving,
        immHireContactData: state.hireContactData,
        immHireCreditLimit: state.hireCreditLimit,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immHirePaymentMethod: state.hirePaymentMethod,
        immProfile: state.profile,
        immPreContractualMail: state.preContractualMail,
        immPdfData: state.precontractualsMergePdfs,
        immShippingAddressList: state.shippingAddress,
    }),
    {
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getScoring: hireCardRevolvingActions.getScoring,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        handleAccountChange: hireCardRevolvingActions.setAccount,
        handleAgreementCheckboxChange: hireCardRevolvingActions.setAgreementCheckbox,
        hireCardRevolving: hireCardRevolvingActions.hireCardRevolving,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        reset: hireCardRevolvingActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        requestProfile: profileActions.requestProfile,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        setAllAccountsToInactive: hireCardRevolvingActions.setAllAccountsToInactive,
        setHireCreditLimit: hireCreditLimitActions.setHireCreditLimit,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setVisibleStep: hireCardRevolvingActions.setVisibleStep,
        setWillCancel: hireCardRevolvingActions.setWillCancel,
        toggleCreditLimitModal: hireCreditLimitActions.toggleModal,
        validate: hireCardRevolvingActions.validate,
        validateStep: hireCardRevolvingActions.validateStep,
    }
)(withRouter(HireCardRevolvingView));
